
export function base64urlToBuffer(
	baseurl64String
) {
	// Base64url to Base64
	const padding = "==".slice(0, (4 - (baseurl64String.length % 4)) % 4);
	const base64String =
		baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;

	// Base64 to binary string
	const str = atob(base64String);

	// Binary string to buffer
	const buffer = new ArrayBuffer(str.length);
	const byteView = new Uint8Array(buffer);
	for (let i = 0; i < str.length; i++) {
		byteView[i] = str.charCodeAt(i);
	}
	return buffer;
}

export function bufferToBase64url(buffer) {
	// Buffer to binary string
	const byteView = new Uint8Array(buffer);
	let str = "";
	for (const charCode of byteView) {
		str += String.fromCharCode(charCode);
	}

	// Binary string to base64
	const base64String = btoa(str);

	// Base64 to base64url
	// We assume that the base64url string is well-formed.
	const base64urlString = base64String
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=/g, "");
	return base64urlString;
}

export function convertStartRegResponse(response) {
	console.log(response);
	var credOpts = angular.copy(response);

	credOpts.publicKey.challenge = base64urlToBuffer(response.publicKey.challenge);
	credOpts.publicKey.user.id = base64urlToBuffer(response.publicKey.user.id);
	credOpts.publicKey.excludeCredentials = [];
	response.publicKey.excludeCredentials.forEach((item) => {
		var itemId = base64urlToBuffer(item.id);
		var newItem = angular.copy(item);
		newItem.id = itemId;
		credOpts.publicKey.excludeCredentials.push(newItem);
	});
	return credOpts
}

export function convertFinishRegRequest(credentials, startResponse) {
	console.log(credentials);
	console.log(credentials.getClientExtensionResults());
	var credResponse = {
		authenticatorAttachment: credentials.authenticatorAttachment, 
		id: credentials.id, 
		rawId: bufferToBase64url(credentials.rawId),
		response: {
			attestationObject: bufferToBase64url(credentials.response.attestationObject),
			clientDataJSON: bufferToBase64url(credentials.response.clientDataJSON)
		},
		clientExtensionResults: credentials.getClientExtensionResults(),// bufferToBase64url(credentials.getClientExtensionResults()),
		type: credentials.type
	};
	console.log(credResponse);
	var finishRegRequest = { challenge: startResponse.publicKey.challenge, credentialResp: credResponse };
	return finishRegRequest;
}

export function convertFinishAuthRequest(credentials,startResponse){
	//console.log(credentials);
	//console.log(credentials.getClientExtensionResults());
	var credResponse = {
			authenticatorAttachment: credentials.authenticatorAttachment,
		   id: credentials.id,
		   rawId: bufferToBase64url(credentials.rawId),
		   response: {
		     authenticatorData: bufferToBase64url(credentials.response.authenticatorData),
		     signature: bufferToBase64url(credentials.response.signature),
		     clientDataJSON: bufferToBase64url(credentials.response.clientDataJSON),
		     userHandle: credentials.response.userHandle
		   },
		   clientExtensionResults: credentials.getClientExtensionResults(),
		   type: credentials.type
	};
	console.log("ready auth resp");
	console.log(credResponse);
	var finishRegRequest = { challenge: startResponse.publicKey.challenge, credentialResp: credResponse };
	console.log(finishRegRequest);
	return finishRegRequest;
	
}

export function convertStartAuthResponse(response) {
	console.log(response);
	var credOpts = angular.copy(response);

	credOpts.publicKey.challenge = base64urlToBuffer(response.publicKey.challenge);
	if(response.publicKey.hasOwnProperty('allowCredentials')){
		credOpts.publicKey.allowCredentials=[];
		response.publicKey.allowCredentials.forEach((item) => {
			var itemId = base64urlToBuffer(item.id);
			var newItem = angular.copy(item);
			newItem.id = itemId;
			credOpts.publicKey.allowCredentials.push(newItem);
		});
	}
	console.log("converted test resp");
	console.log(credOpts);
	return credOpts;
}


// WEBPACK FOOTER //
// ./src/portal/lib/yubico-webauthn.js